// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { InvoicesDataViewContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { xScreen } from "@rc/XDL/Utilities";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps { }

type Props = OwnProps;

export interface InvoiceHistoryNumberAndPaginationContainerStyles { }

export const headerStyles: InvoiceHistoryNumberAndPaginationContainerStyles = {};
const styles = headerStyles;

const InvoiceHistoryNumberAndPaginationContainer: FC<Props> = ({ id }) => {
    const invoicesDataView = useContext(InvoicesDataViewContext);
    const invoicesCount =
        invoicesDataView.value && invoicesDataView.pagination ? invoicesDataView.pagination.totalItemCount : 0;

    return (
        <StyledWrapper
            css={css`
                margin-bottom: 32px;
            `}
        >
            <StyledWrapper
                css={css`
                    padding: 13px;
                    margin: 32px 0 15px;
                    border: 1px solid ${getColor("common.border")};
                `}
            >
                <GridContainer
                    css={css`
                        > div {
                            justify-content: space-between;
                        }
                    `}
                >
                    <GridItem
                        width={[12, 12, 4, 6, 6]}
                        css={css`
                            display: flex;
                            align-items: center;
                            > div {
                                margin: auto;
                            }
                            ${xScreen("lte", "sm")} {
                                padding: 25px 12px 10px 12px;
                            }
                        `}
                    >
                        <Typography
                            css={css`
                                color: ${getColor("common.ui7")};
                                font-size: 18px;
                                font-weight: 500;
                                line-height: 24px;
                            `}
                        >
                            {invoicesCount} {translate("Invoices")}
                        </Typography>
                    </GridItem>
                    <GridItem
                        width={[12, 12, 7, 6, 6]}
                        css={css`
                            padding: 0 15px 0 0;
                            ${xScreen("gt", "sm")} {
                                padding: 13px;
                            }
                            ${xScreen("lte", "sm")} {
                                padding: 0 12px 20px 12px;
                            }
                        `}
                    >
                        <Zone contentId={id} zoneName="TopPaginaton" />
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: InvoiceHistoryNumberAndPaginationContainer,
    definition: {
        group: "Invoice History",
        displayName: "Invoice Number And Pagination Container",
        allowedContexts: ["InvoiceHistoryPage"],
    },
};

export default widgetModule;
